var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C20101",
    d: "M11.98 0A12.2 12.2 0 000 12.2 11.78 11.78 0 0011.8 24h.21a12.11 12.11 0 008.46-20.63A11.77 11.77 0 0011.98 0zM10.5 16.54a1.48 1.48 0 011.45-1.53h.03a1.53 1.53 0 011.43 2.05 1.48 1.48 0 01-1.36.95h-.03a1.53 1.53 0 01-1.52-1.47zm.5-4.04v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorExclamation);
export default __webpack_public_path__ + "static/media/error-exclamation.29f511de5a3f31481a20e1f854e23a6d.svg";
export { ForwardRef as ReactComponent };